export default __webpack_public_path__ + "static/media/smartPhone.d18634cc.png";